/* eslint-disable prefer-destructuring */
import { ENUM_STATUS_GAME } from "constants"

import React, { useState, useEffect, useMemo, useRef } from "react"

import CustomButton from "components/CustomButton"
import useEventListener from "hooks/useEventListener"
import { getTextByShadow, getPointBySeriAndShadow, loadImage } from "utils"

import Title from "../common/Title"

const Equal = ({ setStatus, series, shadow, setShadow, amIsetShadow }) => {
    const leftCanvasRef = useRef(null)
    const leftImageRef = useRef(null)
    const leftCanvasWrapperRef = useRef(null)
    const rightCanvasRef = useRef(null)
    const rightCanvasWrapperRef = useRef(null)
    const ref = useRef(null)


    const [leftSeri, setLeftSeri] = useState(null)
    const [rightSeri, setRightSeri] = useState(null)

    const drawCanvas = async(canvasRef, canvasWrapperRef, seri) => {
        const canvas = canvasRef.current
        const ctx = canvas.getContext("2d")

        canvas.width = canvasWrapperRef.current.clientWidth

        const background = await loadImage(
            "https://firebasestorage.googleapis.com/v0/b/daudit-145c2.appspot.com/o/dolla_result.jpg?alt=media&token=0cf422e0-05d8-49ab-9ed5-e7e09d2a1d74"
        )
        const w = background.width
        const h = background.height

        const ratio = canvas.width / w
        canvas.height = h * ratio

        ctx.drawImage(background, 0, 0, w * ratio, h * ratio)

        const canvasW = canvas.width
        const canvasH = canvas.height

        ctx.font = `${27 * ratio}px Arial`
        const text = `PO ${seri}`.split("").join(String.fromCharCode(8202))

        ctx.fillText(text, canvasW * 0.1, canvasH * 0.71)

        const { indexes } = shadow
        indexes.forEach((index) => {
            ctx.fillStyle = "#aa223b"
            ctx.fillRect(
                (0.262 + index * 0.053) * canvasW,
                0.74 * canvasH,
                0.04 * canvasW,
                0.02 * canvasH
            )
        })
    }

    useEffect(() => {
        let tempLeftSeri = series[0]
        let tempRightSeri = series[1]
        if ((amIsetShadow && !shadow.is_hand_left) || (!amIsetShadow && shadow.is_hand_left)){
            tempLeftSeri = series[1]
            tempRightSeri = series[0]
        }

        setLeftSeri(tempLeftSeri)
        setRightSeri(tempRightSeri)
    }, [])

    const draw2Canvas = () => {
        if (!leftSeri || !rightSeri){
            return
        }
        drawCanvas(leftCanvasRef, leftCanvasWrapperRef, leftSeri)
        drawCanvas(rightCanvasRef, rightCanvasWrapperRef, rightSeri)
    }

    useEffect(() => {
        draw2Canvas()
    }, [leftSeri, rightSeri])

    useEventListener("resize", () => {
        draw2Canvas()
    })

    const handleDone = async() => {
        setStatus(ENUM_STATUS_GAME.READY)
        setShadow(null)
    }

    const textShadow = useMemo(() => {
        return getTextByShadow(shadow)
    }, [])

    const showEqual = () => {
        let classNameFontColor = "text-quaternary"
        let equal = "Bạn yêu và máy đã hòa !!!"
        if (!leftSeri || !rightSeri){
            return
        }
        const myPoint = getPointBySeriAndShadow(leftSeri, shadow)
        const competitorPoint = getPointBySeriAndShadow(rightSeri, shadow)

        if (myPoint !== competitorPoint){
            const tempMyPoint = shadow.is_biggest_num ? myPoint : competitorPoint
            const tempCompetitorPoint = shadow.is_biggest_num ? competitorPoint : myPoint
            if (tempMyPoint > tempCompetitorPoint && myPoint !== 0){
                classNameFontColor = "text-primary--darknight"
                equal = "Bạn yêu đã thắng ^^"
            } else {
                classNameFontColor = ""
                equal = "Bạn yêu đã thua =="
            }
        }

        return (
            <p className={ `mt-4 text-center text-xl font-semibold ${classNameFontColor}` }>
                { equal }
            </p>
        )
    }

    return (
        <>
            <div className="pb-4" ref={ ref }>
                <Title>3. Kết quả</Title>

                <p className="text-lg font-semibold tracking-wide text-center">
                    Bóng: { textShadow }
                </p>

                <div className="flex flex-col space-y-6 tablet:space-y-0 tablet:flex-row px-4 pt-4">
                    <div className="tablet:w-1/2 p-4 border-solid	 border-[3px] border-border rounded-lg	tablet:border-0 text-center ">
                        <p className="tablet:text-lg font-semibold mb-1 ">Tôi</p>

                        <div className="relative" ref={ leftCanvasWrapperRef }>
                            <canvas ref={ leftCanvasRef } />

                            <img alt="" ref={ leftImageRef } />
                        </div>

                        { leftSeri && (
                            <>
                                <p className="mt-2 tracking-wider text-quinary">Seri: { leftSeri }</p>

                                <p className="font-semibold text-lg mt-1">
                                    Điểm: { getPointBySeriAndShadow(leftSeri, shadow) }
                                </p>
                            </>
                        ) }
                    </div>

                    <div className="tablet:w-1/2 p-4 border-solid	 border-[3px] border-primary--light rounded-lg text-center	tablet:border-0">
                        <p className="tablet:text-lg font-semibold mb-1 text-primary">Máy</p>

                        <div ref={ rightCanvasWrapperRef }>
                            <canvas ref={ rightCanvasRef } />
                        </div>

                        { rightSeri && (
                            <>
                                <p className="mt-2 tracking-wider text-quinary">
                                    Seri: { rightSeri }
                                </p>

                                <p className="font-semibold text-lg mt-1">
                                    Điểm: { getPointBySeriAndShadow(rightSeri, shadow) }
                                </p>
                            </>
                        ) }
                    </div>
                </div>

                { showEqual() }
            </div>

            <CustomButton className="w-full h-[44px] mt-8" onClick={ handleDone }>
                Làm trận mới
            </CustomButton>
        </>
    )
}

export default Equal
